import { useState } from 'react';
import { TariffClassificationApiModel } from '~/lib/api/smartsend/types';
import { TariffCode } from './TariffCode';
import Loading from '../../../../components/loading/Loading';
import { Expansion } from './Expansion';
import SelectOrCopy from '../smartsend/item/SelectOrCopy';
import { P2GBox, P2GText, P2GGrid, P2GLinkGroup, P2GLink } from '@parcel2go/core-ui';

interface props {
  classifiction: TariffClassificationApiModel;
  getClassifications?: (code: string) => Promise<TariffClassificationApiModel[]>;
  selectCode: (code: string) => void;
  canSelect: boolean;
}

const TariffClassifiction: React.FC<props> = (props) => {
  const [classifications, setClassifications] = useState<TariffClassificationApiModel[]>([]);
  const [loading, setLoading] = useState(false);

  const loadClassifications = () => {
    setLoading(true);
    if (props.getClassifications) {
      props.getClassifications(props.classifiction.Code).then((x) => {
        setClassifications(x);
        setLoading(false);
      });
    }
  };

  if (props.classifiction.Selectable) {
    return (
      <P2GBox p={1} bordered>
        <P2GText>
          <strong>{props.classifiction.Description}</strong>
        </P2GText>
        <P2GBox pt={1}>
          <P2GGrid container alignItems="center" alignContent="center" spacing={2}>
            <P2GGrid item flexShrink={1}>
              <TariffCode selectable={true} code={props.classifiction.Code} />
            </P2GGrid>
            <P2GGrid item flexShrink={1}>
              <P2GLinkGroup
                links={[
                  props.canSelect && (
                    <P2GLink onClick={() => props.selectCode(props.classifiction.Code)}>Select</P2GLink>
                  ),
                  <SelectOrCopy code={props.classifiction.Code} display="Copy" copied="Copied" />
                ]}
              />
            </P2GGrid>
          </P2GGrid>
        </P2GBox>
      </P2GBox>
    );
  }

  return (
    <P2GBox>
      <P2GBox onClick={loadClassifications} bordered p={1}>
        <P2GBox>
          <P2GLink>{props.classifiction.Description}</P2GLink>
        </P2GBox>
        <P2GBox pt={1}>
          <TariffCode selectable={false} code={props.classifiction.Code} />
        </P2GBox>
      </P2GBox>
      {loading && <Loading />}
      {classifications.length > 0 && (
        <Expansion mt={1}>
          {classifications.map((x) => (
            <P2GBox mb={1} key={x.Id}>
              <TariffClassifiction
                canSelect={props.canSelect}
                selectCode={props.selectCode}
                classifiction={x}
                getClassifications={props.getClassifications}
              />
            </P2GBox>
          ))}
        </Expansion>
      )}
    </P2GBox>
  );
};

export { TariffClassifiction };
